import { Injectable } from '@angular/core';

const CODE_VERIFIER_KEY = 'pkce_code_verifier';

@Injectable()
export class PkceStorageService {
  storeVerifier(verifier: string): void {
    sessionStorage.setItem(CODE_VERIFIER_KEY, verifier);
  }

  getVerifier(): string | null {
    return sessionStorage.getItem(CODE_VERIFIER_KEY);
  }

  clear(): void {
    sessionStorage.removeItem(CODE_VERIFIER_KEY);
  }
}
